import request from '@/utils/http';
import { SRM, SRM_FILE } from '../constant/constant.js';


// 挂靠车列表
export const supplierAffiliatedVehiclePage = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/page`,
        method: 'post',
        data,
    });
};

//挂靠车启用
export const supplierAffiliatedVehicleEnable = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/enable`,
        method: 'post',
        data
    });
};

//挂靠车停用
export const supplierAffiliatedVehicleDisable = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/disable`,
        method: 'post',
        data
    });
};

//挂靠车新增
export const supplierAffiliatedVehicleAdd = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/add`,
        method: 'post',
        data
    });
};

//挂靠车编辑
export const supplierAffiliatedVehicleEdit = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/edit`,
        method: 'post',
        data
    });
};

//挂靠车退出
export const supplierAffiliatedVehicleQuit = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/quit`,
        method: 'post',
        data
    });
};

//挂靠车详情
export const supplierAffiliatedVehicleDetail = id => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/detail/${id}`,
        method: 'get',
        // params
    });
};

//挂靠车退出流程表单
export const supplierAffiliatedVehicleGetFormData = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/getFormData`,
        method: 'post',
        data
    });
};

//挂靠合同列表
export const supplierAffiliatedVehicleContractPage = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicleContract/page`,
        method: 'post',
        data
    });
};

//新增挂靠协议合同
export const supplierAffiliatedVehicleContractAdd = data => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicleContract/add`,
        method: 'post',
        data
    });
};

//新增挂靠协议合同
export const supplierAffiliatedVehicleContractDel = id => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicleContract/${id}`,
        method: 'delete',
        // data
    });
};

//自有车操作记录
export const supplierCarOwnerOperateLogPage = data => {
    return request({
        url: `${SRM}/supplierCarOwnerOperateLogPage`,
        method: 'post',
        data
    });
};

//挂靠车资料导出
export const exportRegister = data => {
    return request({
        url: `${SRM_FILE}/supplierAffiliatedVehicle/exportRegister`,
        method: 'post',
        data
    });
};

//挂靠车处理异常标签
export const handleAbnormalFlagJob = params => {
    return request({
        url: `${SRM}/supplierAffiliatedVehicle/handleAbnormalFlagJob`,
        method: 'get',
        params
    });
};

